import React, {useEffect, useState} from 'react';
import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Select,
  Upload,
  Radio,
  message,
} from 'antd';
import {useLocation, useParams} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import dayjs from 'dayjs';
import './style.css';
import CommonEditor from '../../../CommonComponents/TextEditor';
import {InfoCircleFilled, UploadOutlined} from '@ant-design/icons';
import {applicationConfig} from '../../../../Util/config';
import {
  IsScheduleAvailable,
  NoEmptySpaceInput,
  UploadFileMaxSize,
  displayFileName,
  commonSelectAll,
  emailTemplatesTypeCode,
  getDynamicValuesByEmailTemplateType,
  getEmailDetails,
  isAnnouncementStyleEmailTemplate,
  maxTagPlaceholder,
  tagRender,
} from '../../../../Util/commonUtility';
import {useDispatch} from 'react-redux';
import moment from 'moment';
import {FETCH_ERROR} from '../../../../Constant/ActionTypes';
import useLocalization from '../../../../Localization';

const EventTempFormComponent = (props) => {
  const allTemplateDynamicVariables = getDynamicValuesByEmailTemplateType();
  const {
    postEventTemplateScheduler,
    emailCodeList,
    EditData,
    updateEventTemplateScheduler,
    eventTemplateSchedulerData,
    fetchEventTemplateSchedulerById,
    emailTemplateCode,
    isEventTemplateEdit,
    eventStartDateForEventTemp,
    allScheduledDates,
    localChaptersList,
    mailPreferenceChaptersList,
  } = props;

  const {id, action} = useParams();
  const isEditSchedule = action === 'updateTemplateSchedule';
  const [submitLabel, setSubmitLabel] = useState('Submit');
  const [form] = Form.useForm();
  const [editorCodeState, setEditorCodeState] = useState(`<p></p>`);
  const [selectdOption, setSelectdOption] = useState({});
  const Navigate = useNavigate();
  let dispatch = useDispatch();
  const location = useLocation();
  const {ApplicationString} = useLocalization();

  const currentURL = location.pathname;
  const [isAddEmail, setIsAddEmail] = useState(currentURL.includes('add'));
  const showScheduleFields = isAddEmail || isEditSchedule;
  const [logoIds, setLogoIds] = useState([]);
  const [allLogoIds, setAllLogoIds] = useState([]);
  const [dynamicVariables, setDynamicVariables] = useState(
    allTemplateDynamicVariables,
  );
  const [isScheduleAvailable, setIsScheduleAvailable] = useState(false);
  const [validFileList, setValidFileList] = useState([]);
  const [isEmailTemplate, setIsEmailTemplate] = useState(isEventTemplateEdit);
  const watchedEmailTemplateType = Form.useWatch('email_template_type', form);
  const currentEmailTemplateType =
    watchedEmailTemplateType ||
    selectdOption?.email_template_type ||
    EditData?.email_template_type;
  const showChapterTargetingFields = isAnnouncementStyleEmailTemplate(
    currentEmailTemplateType,
  );
  const [localChapterCheckboxState, setLocalChapterCheckboxState] = useState(
    [],
  );
  const [mailPrefCheckboxState, setMailPrefCheckboxState] = useState([]);

  const localChapterValuesExceptAll = (localChaptersList || [])
    .filter((item) => item?.value !== 'all')
    .map((item) => item?.value);

  const mailPrefChapterValuesExceptAll = (mailPreferenceChaptersList || [])
    .filter((item) => item?.value !== 'all')
    .map((item) => item?.value);

  // Checkbox is display-only (pointerEvents: none) so clicks go to Select.
  // Interactive Checkbox onChange + Select onChange would double-toggle and cancel selection.
  const buildChapterSelectOptions = (checkboxState, chaptersList) =>
    (chaptersList &&
      commonSelectAll(chaptersList)?.map((item) => ({
        label: (
          <Checkbox
            checked={checkboxState.includes(item.value)}
            style={{pointerEvents: 'none'}}>
            {item.label}
          </Checkbox>
        ),
        value: item.value,
        searchLabel:
          typeof item.label === 'string'
            ? item.label
            : String(item.label ?? ''),
      }))) ||
    [];

  const handleChapterMultiSelectChange =
    (fieldName, setCheckboxState, chapterValuesExceptAll) => (value) => {
      if (value.includes('all')) {
        setCheckboxState([...chapterValuesExceptAll, 'all']);
        form.setFieldsValue({[fieldName]: chapterValuesExceptAll});
      } else {
        setCheckboxState(value);
      }
    };

  // const uploadProps = {
  //   name: 'fileLogos',
  //   accept: 'image/*, application/pdf',
  //   multiple: false,
  //   maxCount: 1,
  //   listType: 'text',
  // };

  // const { Panel } = Collapse;

  // const handleEmailTemplateSearch = (value) => {
  //   setFetching(true);
  //   const Data = {
  //     details: value,
  //   };
  //   const searchQueryData = queryString(Data);
  //   dispatch(
  //     getAllEmailCodesSearch('', '', searchQueryData, {
  //       page: 1,
  //       pageCount: 10,
  //     }),
  //   );
  // };
  // const handleEmailTemplatForMouseLeave = (value) => {
  //   if (emailCodeList?.length === 0) {
  //     dispatch(
  //       getAllEmailCodesSearch('', '', '', {
  //         page: 1,
  //         pageCount: 100,
  //       }),
  //     );
  //   }
  // };
  // const handleEmailTemplateAllowClear = (value) => {
  //   dispatch(
  //     getAllEmailCodesSearch('', '', '', {
  //       page: 1,
  //       pageCount: 100,
  //     }),
  //   );
  // };

  const getTemplateIdByType = (emailTemplateType) => {
    const template = emailCodeList?.find(
      (t) => t.email_template_type === emailTemplateType,
    );
    return template ? template.id : null;
  };

  useEffect(() => {
    if (action === 'updateTemplate') {
      setIsEmailTemplate(true);
    }
  }, [action]);

  useEffect(() => {
    setIsAddEmail(currentURL.includes('add'));
    if (!isAddEmail) {
      fetchEventTemplateSchedulerById(id);
      setSubmitLabel('Update');
    }
  }, []);

  const filesFormats = [
    // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    // 'application/msword',
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/jpg',
  ];

  const uploadProps = {
    name: 'file',
    multiple: true,
    maxCount: 10,
    // listType: 'picture',
    beforeUpload: (file) => {
      const isRightFormat = filesFormats.includes(file.type);
      if (!isRightFormat) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Accepted file formats: PDF, JPG and PNG only',
        });
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < UploadFileMaxSize;
      if (!isLt2M) {
        dispatch({
          type: FETCH_ERROR,
          payload: `File must smaller than ${UploadFileMaxSize}MB.`,
        });
        return false;
      }

      setValidFileList((prev) => {
        if (prev.length >= 10) {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Maximum 10 files can be uploaded',
          });
          return prev;
        }
        return [...prev, file];
      });
      return isRightFormat && isLt2M;
    },
  };

  const removeFileHandler = (file) => {
    setValidFileList((prevFileList) => {
      return prevFileList.filter((item) => item?.uid !== file?.uid);
    });
  };

  useEffect(() => {
    if (!isAddEmail) {
      const selectedEmailCode = EditData?.email_template_body;
      setEditorCodeState(selectedEmailCode);
      const dynamicVariable = getDynamicValuesByEmailTemplateType(
        EditData?.email_template_type,
      );
      setDynamicVariables(dynamicVariable);
      const hasScheduleDate = Boolean(EditData?.schedule_date);
      setIsScheduleAvailable(hasScheduleDate);
      form.setFieldsValue({
        ...EditData,
        code_id: getTemplateIdByType(EditData?.email_template_type),
        is_scheduled: hasScheduleDate,
        schedule_date: hasScheduleDate
          ? moment.utc(EditData.schedule_date).format('YYYY-MM-DD')
          : null,
        local_chapter_ids: EditData?.local_chapter_ids ?? [],
        mail_preference_chapter_ids:
          EditData?.mail_preference_chapter_ids ?? [],
      });
      setLocalChapterCheckboxState(EditData?.local_chapter_ids ?? []);
      setMailPrefCheckboxState(EditData?.mail_preference_chapter_ids ?? []);

      EditData?.attachment_ids?.length > 0
        ? setValidFileList((prev) =>
            EditData?.attachment_ids?.map((eFile) => {
              return {
                uid: eFile.id,
                name: displayFileName(eFile),
                status: 'done',
                url: `${applicationConfig.UPLOAD_URL}/${eFile.name}`,
              };
            }),
          )
        : setValidFileList((prev) => []);
    }
  }, [EditData]);

  const handalSelect = (value, option) => {
    const emailSubject = option?.details;
    form.setFieldValue('subject', emailSubject);
    setSelectdOption(option);
    const selectedEmailCode = option?.email_template;
    setEditorCodeState(selectedEmailCode);
    const dynamicVariable = getDynamicValuesByEmailTemplateType(
      option?.email_template_type,
    );
    setDynamicVariables(dynamicVariable);
    form.setFieldsValue({
      email_template_body: selectedEmailCode,
      email_template_type: option.email_template_type, // Update the form field directly
    });
  };

  const onFinish = (values) => {
    const scheduleData = {
      ...values,
      // id: EditData?.id,
      // email_attachments:EditData?.email_attachments,
      // attachment_ids: logoIds,
      event_id: isAddEmail ? id : EditData?.event_id,
      email_template_body: editorCodeState,
    };
    const formData = new FormData();
    Object.entries(scheduleData).forEach(([key, value]) => {
      if (key === 'is_scheduled') return;
      if (key === 'schedule_date') {
        formData.append(key, isScheduleAvailable ? value ?? '' : '');
        return;
      }

      if (key === 'email_attachments') {
        // check if we are editing or not
        if (!isAddEmail) {
          const attachmentIds = [];
          if (EditData?.attachment_ids?.length > 0) {
            // if we have attachments then send them as ids and new ones as attachments

            validFileList.forEach((validFile) => {
              EditData?.attachment_ids?.some(
                (file) => file?.id === validFile?.uid,
              )
                ? attachmentIds.push(validFile?.uid)
                : formData.append(
                    'email_attachments',
                    validFile?.originFileObj || validFile,
                  );
            });
            formData.append('attachment_ids', `[${attachmentIds}]`);
          } else {
            values?.email_attachments?.forEach((file) =>
              formData.append(`email_attachments`, file?.originFileObj || file),
            );
          }
        } else {
          // not editing so just append all files
          setValidFileList((prev) => []);
          values?.email_attachments?.forEach((file) =>
            formData.append(`email_attachments`, file?.originFileObj || file),
          );
        }
      } else if (
        key === 'local_chapter_ids' ||
        key === 'mail_preference_chapter_ids'
      ) {
        formData.append(key, JSON.stringify(value ?? []));
      } else {
        formData.append(key, value);
      }
    });
    if (!isScheduleAvailable && !formData.has('schedule_date')) {
      formData.append('schedule_date', '');
    }
    if (!isAddEmail) {
      updateEventTemplateScheduler(formData, EditData?.id);
      // onReset();
    } else {
      postEventTemplateScheduler(formData);
      // onReset();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error(errorInfo);
  };

  const onReset = () => {
    form.resetFields();
  };

  const backToEventSchedulers = () => {
    Navigate(
      `/admin/eventEmailTemplatesScheduler/${
        isAddEmail ? id : EditData?.event_id
      }`,
    );
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const dummyRequest = ({file, onSuccess}) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };
  const beforeUploadFlyer = (file) => {
    const reader = new FileReader();
    const fileSize = file.size / 1024;
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        // if (width !== 1080 && height !== 1080) {
        //   message.error('Image must be 1080px x 1080px!');
        //   return Upload.LIST_IGNORE;
        // }
      };
      if (fileSize > 2) {
        message.error('File size must not exceed 2MB!');
        return Upload.LIST_IGNORE;
      }
      return true;
    };

    reader.readAsDataURL(file);
  };

  const handleScheduleChange = (values) => {
    const scheduled = Boolean(values.target.value);
    setIsScheduleAvailable(scheduled);
    if (!scheduled) {
      form.setFieldsValue({schedule_date: null});
    }
  };

  const handleDeleteLogo = (logoId) => {
    const updatedLogoIds = allLogoIds?.filter((logo) => logo.id !== logoId);
    const idsArray = updatedLogoIds.map((item) => item.id);
    setLogoIds(JSON.stringify(idsArray));
    setAllLogoIds(updatedLogoIds);
  };

  const setDynamicVariable = (value, option) => {
    setDynamicVariables(getDynamicValuesByEmailTemplateType(value));
  };

  const getScheduledDateStrings = () => {
    let dates = allScheduledDates.map((item) =>
      moment.utc(item).format('YYYY-MM-DD'),
    );
    if (!isAddEmail) {
      const currentDateNotDisabled = moment
        .utc(EditData.schedule_date)
        .format('YYYY-MM-DD');
      dates = dates.filter((date) => date !== currentDateNotDisabled);
    }
    return dates;
  };

  const disableDatehandler = (current) => {
    const currentDate = moment().format('YYYY-MM-DD');
    const customDate = moment(eventStartDateForEventTemp).format('YYYY-MM-DD');
    const scheduled = getScheduledDateStrings();
    return (
      current < moment(currentDate).endOf('day') ||
      current.isAfter(customDate) ||
      scheduled.includes(current.format('YYYY-MM-DD'))
    );
  };

  const cellRender = (current, info) => {
    const scheduled = getScheduledDateStrings();
    if (scheduled.includes(current.format('YYYY-MM-DD'))) {
      return (
        <div className='event-temp-scheduled-date'>{info?.originNode}</div>
      );
    }

    return info?.originNode;
  };

  return (
    <div className='head-main-container'>
      <div className='main-form-container'>
        <Form
          form={form}
          name='basic'
          onFinish={onFinish}
          layout='vertical'
          className='two-column-form'
          autoComplete='off'>
          <div className='input-container'>
            <div className='form-column'>
              {/* <Form.Item hidden name='id'></Form.Item> */}
              {/* <Form.Item
                name='event_id'
                // label='Select Your Event'
                initialValue={isAddEmail ? id : EditData?.event_id}
                // rules={[{required: true, message: 'Event  should not be empty'}]}
              >
                {/* <Select
                  prefixCls='common-select-register'
                  showSearch
                  className='space'
                  optionFilterProp='children'
                 filterOption={(input, option) =>
                    option?.label.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  placeholder={'Select your Event'}
                  options={eventsList}></Select> */}
              {/* </Form.Item> */}
              <Form.Item
                label='Email Template'
                name='code_id'
                hidden={!isEmailTemplate && !isAddEmail}
                rules={[
                  {
                    required: isAddEmail,
                    message: 'Email template should not be empty',
                  },
                ]}>
                <Select
                  // disabled={!isAddEmail}
                  prefixCls='common-select-register'
                  className='space'
                  placeholder='Select email template'
                  showSearch
                  allowClear
                  onChange={(value, option) => handalSelect(value, option)}
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    option?.label.toLowerCase().indexOf(input.toLowerCase()) >=
                    0
                  }
                  options={emailCodeList}
                />
              </Form.Item>
              {(selectdOption?.email_template_type ||
                EditData?.email_template_type) && (
                <div className='info-container'>
                  <InfoCircleFilled />
                  <p className='content-info'>
                    {getEmailDetails(currentEmailTemplateType).description}
                  </p>
                </div>
              )}

              {showChapterTargetingFields && (
                <>
                  <Form.Item
                    label='Local Chapter'
                    name='local_chapter_ids'
                    tooltip='Send to all users whose local chapter is one of the selected chapters, regardless of mail preference.'>
                    <Select
                      id='event-template-local-chapter-select'
                      prefixCls='common-select-register'
                      className='space'
                      mode='multiple'
                      showSearch
                      allowClear
                      optionFilterProp='children'
                      filterOption={(input, option) =>
                        String(option?.searchLabel ?? option?.label ?? '')
                          .toLowerCase()
                          .includes(String(input ?? '').toLowerCase())
                      }
                      placeholder='Select local chapter(s)'
                      onChange={handleChapterMultiSelectChange(
                        'local_chapter_ids',
                        setLocalChapterCheckboxState,
                        localChapterValuesExceptAll,
                      )}
                      maxTagCount='responsive'
                      maxTagPlaceholder={maxTagPlaceholder}
                      tagRender={tagRender}
                      options={buildChapterSelectOptions(
                        localChapterCheckboxState,
                        localChaptersList,
                      )}
                    />
                  </Form.Item>
                  <Form.Item
                    label='Mail Preference'
                    name='mail_preference_chapter_ids'
                    tooltip='Send to all users whose mail preference includes one of the selected chapters, regardless of local chapter.'>
                    <Select
                      id='event-template-mail-preference-select'
                      prefixCls='common-select-register'
                      className='space'
                      mode='multiple'
                      showSearch
                      allowClear
                      optionFilterProp='children'
                      filterOption={(input, option) =>
                        String(option?.searchLabel ?? option?.label ?? '')
                          .toLowerCase()
                          .includes(String(input ?? '').toLowerCase())
                      }
                      placeholder='Select mail preference chapter(s)'
                      onChange={handleChapterMultiSelectChange(
                        'mail_preference_chapter_ids',
                        setMailPrefCheckboxState,
                        mailPrefChapterValuesExceptAll,
                      )}
                      maxTagCount='responsive'
                      maxTagPlaceholder={maxTagPlaceholder}
                      tagRender={tagRender}
                      options={buildChapterSelectOptions(
                        mailPrefCheckboxState,
                        mailPreferenceChaptersList,
                      )}
                    />
                  </Form.Item>
                </>
              )}

              <Form.Item
                label='Subject'
                name='subject'
                rules={[
                  {required: true, message: 'Subject should not be empty'},
                  {
                    validator: (_, value) =>
                      NoEmptySpaceInput(value, 'Subject'),
                  },
                ]}>
                <Input
                  prefixCls='common-input-user'
                  className='genral-form'
                  placeholder='Enter subject for the email'
                />
              </Form.Item>
              <Form.Item
                label='Do you want to schedule this email?'
                name='is_scheduled'
                hidden={!showScheduleFields}
                valuePropName='value'>
                <Radio.Group
                  prefixCls='common-radio-group'
                  optionType='button'
                  onChange={handleScheduleChange}
                  buttonStyle='solid'>
                  {Object.entries(IsScheduleAvailable).map(([key, value]) => (
                    <Radio key={key} value={value}>
                      {key}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label='Schedule Date'
                name='schedule_date'
                hidden={!showScheduleFields || !isScheduleAvailable}
                rules={[
                  {
                    required: showScheduleFields && isScheduleAvailable,
                    message: 'Schedule date should not be empty',
                  },
                ]}
                getValueFromEvent={(e) => e?.format('YYYY-MM-DD')}
                getValueProps={(e) => ({value: e && dayjs(e)})}>
                <DatePicker
                  allowClear
                  disabledDate={disableDatehandler}
                  cellRender={cellRender}
                  placeholder='Select schedule date for sending emails'
                  prefixCls='common-input-user'
                  className='genral-form'
                />
              </Form.Item>
              <Form.Item
                label='Email Template Type'
                name='email_template_type'
                hidden='true'
                rules={[
                  {
                    required: true,
                    message: 'Email template type should not be empty',
                  },
                ]}>
                <Select
                  prefixCls='common-select-register'
                  disabled={!isAddEmail}
                  className='space'
                  placeholder='Select email template type'
                  // showSearch
                  allowClear
                  onChange={(value, option) =>
                    setDynamicVariable(value, option)
                  }
                  options={emailTemplateCode}
                />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Email template body should not be empty',
                  },
                ]}
                name='email_template_body'
                hidden={!isEmailTemplate && !isAddEmail}>
                <CommonEditor
                  // disabled={EditData?.id??false}
                  Variables={dynamicVariables}
                  value={editorCodeState}
                  onChange={(value) => setEditorCodeState(value)}
                  text={'email_template_body'}
                  placeholderValue={'email template description'}
                />
              </Form.Item>
              <div className='input-container'>
                <div className='form-column'>
                  <div className='upload-admin'>
                    <Form.Item
                      name='email_attachments'
                      label=''
                      // valuePropName='fileList'
                      getValueFromEvent={normFile}
                      hidden={!isEmailTemplate && !isAddEmail}>
                      <Upload
                        id='adminEventTesting-uploadButton-button'
                        prefixCls='upload-list-name-fix-class-admin'
                        className='common-input-user genral-form height-auto pd-y-20'
                        {...uploadProps}
                        accept='.pdf,.png,.jpg,.jpeg'
                        customRequest={dummyRequest}
                        onRemove={removeFileHandler}
                        fileList={validFileList}
                        showUploadList={true}>
                        <div>
                          <UploadOutlined className='upload-logo-admin' />
                          <div>
                            <span className='upload-text-logos-admin'>
                              Upload Attachment
                            </span>
                          </div>
                          <div className='upload-type-admin'>
                            <span className='upload-desc-admin'>
                              Accepts only pdf/image files (png, jpg, jpeg, pdf)
                            </span>
                            <br />
                            <span className='upload-desc-admin'>
                              Maximum number of files allowed is 10.
                            </span>
                            <br />
                            <span className='upload-desc-admin'>
                              {`Maximum file size is ${UploadFileMaxSize}MB.`}
                            </span>
                          </div>
                        </div>
                      </Upload>
                    </Form.Item>
                  </div>
                </div>
              </div>
              {/* {allLogoIds?.length ? (
                <Form.Item
                  label='Uploaded Attechments'
                  hidden={!isEventTemplateEdit && !isAddEmail}>
                  <div className='logo-list-container'>
                    {allLogoIds?.map((logo, index) => (
                      <div
                        key={index}
                        className='logo-container extend-logo-container'>
                        <Image
                          crossOrigin='anonymous'
                          preview={true}
                          className='sponsor-icon-email-attach'
                          src={
                            logo.name
                              ? `${applicationConfig.UPLOAD_URL}/${logo.name}`
                              : 'https://icons8.com/icon/12053/document'
                          }
                        />
                        <Tooltip prefixCls = 'common-pbss-tooltip' title='Click to delete this logo'>
                          <Button
                            // type='button'
                            className='delete-logo-button'
                            onClick={() => handleDeleteLogo(logo.id)}>
                            <DeleteOutlined />
                          </Button>
                        </Tooltip>
                      </div>
                    ))}
                  </div>
                </Form.Item>
              ) : (
                ''
              )} */}
            </div>
          </div>
          <Form.Item>
            <div className='button-container'>
              <Button
                id='back'
                className='common-submit-login common-form-submit common-form-cancel'
                onClick={backToEventSchedulers}>
                {ApplicationString['common.button.backForm']}
              </Button>
              <div className='form-flex-button'>
                <Button
                  type='primary'
                  htmlType='submit'
                  id='submit'
                  className='common-submit-login common-form-submit'>
                  {submitLabel}
                </Button>
                <Button
                  className='common-submit-login common-form-submit common-form-cancel'
                  htmlType='button'
                  id='clear'
                  onClick={onReset}>
                  {ApplicationString['dynamicSearch.button.reset']}
                </Button>
              </div>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default EventTempFormComponent;
